import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  TextField,
  TablePagination,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment/moment";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import Heading from "../../../../StyledComponents/Heading/Heading";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
});

function ExpenseDetail({ multipleData }) {
  const classes = useStyles();
  const [page, setpage] = useState(0);
  const [RowsPerPage, setRowsPerPage] = useState(20);
  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setpage(0);
  };
  return (
    <div>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          mt={2}
          mb={2}
          style={{ width: "0" }}
        >
          <Heading title="Expense Detail" />
          <TableContainer
            style={{
              maxHeight: "none",
              minHeight: "auto",
              overflowY: "visible",
            }}
          >
            <Table
              className={classes.table}
              aria-label="a dense table"
              // padding="normal"
              size="small"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4", fontSize: "11" }}>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Expense Date
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Expense Type
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Description
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Charge Account
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Cost Center
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Total
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Mobile Expense
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Per Diem
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Per Diem Type
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Date From
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                    Date To
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30", p: 1 }}
                  >
                   Asset Requisition
                  </TableCell>
                 

                
                </TableRow>
              </TableHead>
              <TableBody>
                {multipleData?.erf_ExpenseInvoice_Detail?.length > 0 &&
                  multipleData?.erf_ExpenseInvoice_Detail
                    // ?.slice(
                    //   page * RowsPerPage,
                    //   page * RowsPerPage + RowsPerPage
                    // )
                    .map((item, index) => {
                      return (
                        <TableRow key={index} sx={{ fontSize: "10" }}>
                          <TableCell sx={{ p: 1 }}>{item?.DateIncurred}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.ExpenseType}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Explaination}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.ChargeAccount}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.CostCenter}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.Total}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.IsMobileExpense}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.PerDiem}</TableCell>
                          <TableCell sx={{ p: 1 }}>{item?.DiemType}</TableCell>
                          <TableCell sx={{ p: 1 }}>
                            {item?.DiemDateFrom}
                          </TableCell>
                          <TableCell sx={{ p: 1 }}>
                            {item?.DiemDateTo}
                          </TableCell>
                          <TableCell sx={{ p: 1 }}>
                            {item?.AssetRequisition}
                          </TableCell>
                        
                        </TableRow>
                      );
                    })}
              </TableBody>
              {/* {loading && <TableSkeleton noOfColumns={9} noOfLines={3} />} */}
            </Table>
            {multipleData?.erf_ExpenseInvoice_Detail?.length === 0 ? <EmptyData /> : ""}
            {/* <TablePagination
              rowsPerPageOptions={[10, 20, 30]}
              component="div"
              count={multipleData?.erf_ExpenseInvoice_Detail?.length}
              rowsPerPage={RowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
}

export default ExpenseDetail;
